import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import useTranslation from "../../client/hooks/useTranslation";
import { useThemeId } from "../../client/components/ui/card-section-header";
import { FilterBar } from "../ui/FilterBar";

// Nom japonais affiché à côté du titre, uniquement sur le thème Tokyo Night.
const KANA_BY_PATH: Record<string, keyof ReturnType<typeof useTranslation>["lite"]["kana"]> = {
  "/dashboard": "dashboard",
  "/prop-firm-manager": "propFirms",
  "/trading-accounts": "accounts",
  "/trading-journal": "journal",
  "/trading-sessions": "sessions",
  "/discipline-manager": "discipline",
  "/trading-analytics": "stats",
  "/my-analyses": "edgy",
  "/playbook": "edgy",
  "/reports": "reports",
};

/** En-tête commun des pages Lite : titre, sous-titre, actions, barre de filtres. */
export function PageHeader({ title, subtitle, filters = "full", actions }: {
  title: ReactNode;
  subtitle?: ReactNode;
  filters?: "full" | "noPeriod" | false;
  actions?: ReactNode;
}) {
  const kana = useTranslation().lite.kana;
  const { pathname } = useLocation();
  const tokyo = useThemeId() === "tokyo-night";
  const kanaKey = KANA_BY_PATH[pathname];
  return (
    <div className="pt-2 md:pt-4 pb-5 space-y-4">
      <div className="flex items-end justify-between gap-4">
        <div className="min-w-0">
          <h1 className="font-display text-2xl md:text-[28px] font-bold tracking-tight lite-page-title flex flex-wrap items-baseline gap-x-4 gap-y-1">
            {title}
            {tokyo && kanaKey && <span className="lite-kana text-base md:text-lg" lang="ja">{kana[kanaKey]}</span>}
          </h1>
          {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        {actions}
      </div>
      {filters && <FilterBar showPeriod={filters === "full"} />}
    </div>
  );
}

export function PageBody({ children }: { children: ReactNode }) {
  return <div className="space-y-5 lite-stagger">{children}</div>;
}
